import { useResetRecoilState } from 'recoil';
import { loginState } from '@esg/framework/state';

export function useResetLoginState() {
    return useResetRecoilState(loginState);
}